import React from "react";

interface KeyValueProps {
  label: string;
  value: React.ReactNode;
  mono?: boolean;
}

export function KeyValue({ label, value, mono }: KeyValueProps) {
  return (
    <div
      className="flex items-center justify-between py-2"
      style={{ borderBottom: "1px solid var(--c-active)" }}
    >
      <span className="text-xs" style={{ color: "var(--c-text-secondary)" }}>
        {label}
      </span>
      <span
        className={`text-sm ${mono ? "font-mono text-xs" : ""}`}
        style={{ color: "var(--c-text)" }}
      >
        {value}
      </span>
    </div>
  );
}
